/**
 * @author Arul Vivek
 */
import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants"
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function createApp(data){
    return axiosClient({
        url: constants.api.app.create_app,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}

function createConfigure(data) {
    return axiosClient({
        url: constants.api.app.config,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}


function getAppTypes() {
    return axiosClient({
        url: constants.api.app.getTypes,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    })
}

function getConfigureById(id) {
    return axiosClient({
        url: constants.api.app.getConfigById + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}

function getavailableApps(data, page, size) {
    return axiosClient({
        url: constants.api.app.get_app + "?page=" + page + "&size=" + size,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}

function getAppById(id) {
    return axiosClient({
        url: constants.api.app.getAppById + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}

function appReconfigure(id) {
    return axiosClient({
        url: constants.api.app.re_configure + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader()
    })
}

function restoreVersion(id, versionName, comment) {
    return axiosClient({
        url: constants.api.app.restoreVersion + id + "?versionName=" + versionName + "&comment=" + comment,
        method: HTTP_METHODS.PUT,
        headers: _constructHeader()
    })
}

function captureThumbnail(id) {
    return axiosClient({
        url: constants.api.app.captureThumbnail + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ""
    })
}

//To export run function
const AppService = {
    createApp, createConfigure, getavailableApps, getConfigureById, getAppTypes, getAppById,
    appReconfigure, restoreVersion, captureThumbnail
}
export default AppService;
